<template>
  <mu-dialog
    :open = 'showDialog'
    @close = 'close'
  >
    <div
      style = '
      '
    >
      <mu-radio
        name = 'trainScope'
        label = '所有可选训练'
         = 'all-trains'
        v-model = '
      />
    </div>
  </mu-dialog>
</template>
<script>
  import Vue from 'vue'
  import trainMenu from '../../../common/trainMenu.vue'
  import selectLevel from '../../../common/selectLevel.vue'
  import {removeByValue} from '../../../../assets/js/common.js'
  import {mapState,mapMutations} from 'vuex'

  export default ({
    // 获取父级数据
    props: {
      //已经选择的训练方案
      games: {
        type: Array,
        default: function(){
          return []
        }
      },
      caseId:{
        type: String,
        default: function(){
          return this.$route.params.id
        }
      }
    },
    data() {
      return {
        dialog: false,
        address: GLOBAL.cognition,
        config: GLOBAL,
        showDoTrain: true,
        checkItem:{},
        oneGrade: '',
        twoGrade: '',
        trainList: [],
        trainDailyList:[],
        trainPlanList:[],
        selectTrain:'daily',
        postDaily:[],
        dailyList:[],
        postPlan:[],
        menu:"",
        dailyClass:[],
        dailyCount:0,
        dailyTrainClass:[],
        planCount:0,
        planClass:[],
        planTrainClass:[],
        oneNum:"",
        twoNum:"",
        noContent:false,
        subject:[{value:"daily",text:"显示今日训练"},{value:"plan",text:"显示训练方案"},{value:"all",text:"显示全部"}], //为select组件传递option值
        selectContent:{value:"daily",text:"显示今日训练"},
        selectWidth:120,
        activeTab: '',
        trainScope: 'all-trains',
        showDialog: false,
      }
    },
    components:{
      trainMenu,
      selectLevel
    },
    mounted() {
      this.$refs.body.style.maxHeight = '422px';
      this.getDaily();
      this.repairMuseui();
    },
    computed:{
      content(){
        return `当前没有训练内容！`;
      },
      dom(){
        return document.querySelector(".no-content");
      },
      ...mapState(["startTrain"])
    },
    methods: {
      /* 难度设置开始 */
      close () {
        // this.dialog = false;
        this.showDialog = false;
      },
      /* 难度设置结束 */
      
      // 路由到训练方案
      toTrainPlan (id) {
        this.$router.push({name: 'trainPlan', params: {id: id}});
        this.cancelhandler();
      },
      chooseMenu1 (num) {
        this.menu = num;
        this.oneNum = num;
        this.twoNum = "";
        this.getDaily();
      },
      chooseMenu2(num){
        this.menu = num;
        this.oneNum = num;
        this.twoNum = "";
        this.getPlan();
      },
      changeDaily(item){
        this.trainDailyList = [];
        this.twoNum = item.id;
        for (var i = 0; i < this.dailyTrainClass.length; i++) {
          var labelArr = this.dailyTrainClass[i].label.split(",");
          //每次切换脑能力取消所有的选中效果，否则会有两个训练一块选中的bug
          this.$set(this.dailyTrainClass[i],"checked",false);
          for (var j = 0; j < labelArr.length; j++) {
            if (labelArr[j] == item.id) {
              this.trainDailyList.push(this.dailyTrainClass[i]);
            }
          }
        }
      },
      changePlan(item){
        this.trainPlanList = [];
        this.twoNum = item.id;
        for (var i = 0; i < this.planTrainClass.length; i++) {
          var labelArr = this.planTrainClass[i].label.split(",");
          this.$set(this.planTrainClass[i],"checked",false);
          for (var j = 0; j < labelArr.length; j++) {
            if (labelArr[j] == item.id) {
              this.trainPlanList.push(this.planTrainClass[i]);
            }
          }
        }
      },
      choose(val) {
        this.selectContent.value = val.value;
        if (val.value == "daily") {
          this.getDaily();
        }else if(val.value == "plan"){
          this.getPlan();
        }else if(val.value == "all"){
          this.fetch();
        }
      },
      handleTabChange(val){
        this.activeTab = val;
      },
      getDaily:function(id){
        var self = this;
        Vue.http({
          method: 'GET',
          url:'/api/Train/getDailyTrainingProgram',
          params: {
            'id': self.caseId
          }
        })
        .then(function(res){
          var cogn = res.data.data.cogn;
          var cognList = [];//后台返回的今日训练接口没有精神健康与社会分类，需要在前端手动分类
          var menList = [];
          var dailyArr = [];
          var listAll = cogn.concat(res.data.data.lan);
          if (listAll.length > 0) { //当今日训练有内容时
            self.noContent = false;
            listAll.forEach(function(item,index){//取到所有训练的label值
              var daily = item.label.split(",");
              for (var i = 0; i < daily.length; i++) {
                dailyArr.push(daily[i]);
              }
            })
            dailyArr.sort();
            self.postDaily = [dailyArr[0]];
            for (var j = 0; j < dailyArr.length; j++) { //去掉重复的label值，获取到全部的一级能力
              if (dailyArr[j] !== self.postDaily[self.postDaily.length-1]) {
                self.postDaily.push(dailyArr[j]);
              }
            };
            self.dailyCount++;
            if (self.dailyCount <= 1) { //通过判断点击次数来解决一级脑能力不断叠加的bug
              for (var y = 0; y < self.config.trainClass.length; y++) { //通过label值匹配脑能力对象
                for (var z = 0; z < self.postDaily.length; z++) {
                  if (self.config.trainClass[y].id == self.postDaily[z]) {
                    self.dailyClass.push(self.config.trainClass[y]);
                  }
                }
              }
            }
            if (self.menu == 11) {
              if (res.data.data.lan.length > 0) {
                self.trainDailyList = res.data.data.lan;
              }else{
                self.noContent = true;
                self.trainDailyList = res.data.data.lan;
              }
            }else if(self.menu == 10){ //后台接口没有把精神健康与社会和认知训练区分，通过ID区分开
              cogn.forEach(function(item,index){
                if (item.id != 46001 && item.id != 49001 && item.id != 50001) {
                  cognList.push(item);
                }
              })
              if (cognList.length > 0) {
                self.trainDailyList = cognList;
              }else{
                self.noContent = true;
                self.trainDailyList = cognList;
              }
            }else if(self.menu == 12){
              cogn.forEach(function(item,index){
                if (item.id == 46001 || item.id == 49001 || item.id == 50001) {
                  menList.push(item);
                }
              })
              if (menList.length > 0) {
                self.trainDailyList = menList;
              }else{
                self.noContent = true;
                // self.dom.innerHTML = self.content;
                self.trainDailyList = menList;
              }
            }else{
              self.trainDailyList = res.data.data.cogn.concat(res.data.data.lan);
              self.dailyTrainClass = self.trainDailyList;
            }
          }else{
            self.noContent = true;
          }
        })
      },
      getPlan:function(id){
        var self = this;
        Vue.http({
          method: 'GET',
          url:'api/Train/getManualProgram',
          params: {
            'id': self.caseId
          }
        })
        .then(function(res){
          var cogn = res.data.data.cogn;
          var cognList = [];//后台返回的训练方案接口没有精神健康与社会分类，需要在前端手动分类
          var menList = [];
          var planArr = [];
          var listAll = res.data.data.cogn.concat(res.data.data.lan);
          if (listAll.length > 0) {
            self.noContent = false;
            listAll.forEach(function(item,index){
              var plan = item.label.split(",");
              for (var i = 0; i < plan.length; i++) {
                planArr.push(plan[i]);
              }
            })
            planArr.sort();
            self.postPlan = [planArr[0]];
            for (var j = 1; j < planArr.length; j++) {
              if (planArr[j] !== self.postPlan[self.postPlan.length-1]) {
                self.postPlan.push(planArr[j]);
              }
            };
            self.planCount++;
            if (self.planCount <= 1) {
              for (var y = 0; y < self.config.trainClass.length; y++) {
                for (var z = 0; z < self.postPlan.length; z++) {
                  if (self.config.trainClass[y].id == self.postPlan[z]) {
                    self.planClass.push(self.config.trainClass[y]);
                  }
                }
              }
            }
              if (self.menu == 11) {
                if (res.data.data.lan.length > 0) {
                self.trainPlanList = res.data.data.lan;
              }else{
                self.noContent = true;
                self.dom.innerHTML = self.content;
                self.trainPlanList = res.data.data.lan;
              }
              }else if(self.menu == 10){
                cogn.forEach(function(item,index){
                  if (item.id != 46001 && item.id != 49001 && item.id != 50001) {
                    cognList.push(item);
                  }
                })
                if (cognList.length > 0) {
                  self.trainPlanList = cognList;
                }else{
                  self.noContent = true;
                  self.dom.innerHTML = self.content;
                  self.trainPlanList = cognList;
                }
              }else if(self.menu == 12){
                cogn.forEach(function(item,index){
                  if (item.id == 46001 || item.id == 49001 || item.id == 50001) {
                   menList.push(item);
                  }
                })
                if (menList.length > 0) {
                  self.trainPlanList = menList;
                }else{
                  self.noContent = true;
                  self.dom.innerHTML = self.content;
                  self.trainPlanList = menList;
                }
              }else{
                self.trainPlanList = res.data.data.cogn.concat(res.data.data.lan);
                self.planTrainClass = self.trainPlanList;
              }
          }else{
            self.noContent = true;
            self.dom.innerHTML = self.content;
          }
        })
      },
      fetch: function (id) {
        var self = this;
        self.noContent = false;
        this.trainList = [];
        var obj = {}; //用来供reduce使用的对象
        if (this.oneGrade >= 0){
          Vue.http({
              method: 'GET',
              url: '/api/Game/getAllGames'
            })
            .then(function(res){
              // 区分2.0的言语训练
              if (self.oneGrade == 11){
                self.trainList = res.data.data.lan;
                self.trainList = self.trainList.concat(res.data.data.rehab_lan);//1.0言语部分追加
              } else if(self.oneGrade == 10) {
                self.trainList = res.data.data.cogn;
              } else if(self.oneGrade == 12) {
                self.trainList = res.data.data.men;
              } else {
                self.trainList = res.data.data.cogn.concat(res.data.data.lan).concat(res.data.data.men);
                self.trainList = self.trainList.concat(res.data.data.rehab_lan);//1.0言语部分追加
              }
              self.trainList = self.trainList.reduce((cur,next) => {
                obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
                return cur;
              },[]);
              /*self.$refs.postDailyList.getAll();*/
              // 以下从配置文件中匹配标签
              if(typeof id != 'undefined'){
                var tempList = [];
                for(var x=0; x<self.trainList.length; x++){
                  var tempLabel = self.trainList[x].label.split(',');
                  for(var y=0; y<tempLabel.length; y++){
                    if (tempLabel[y] == id){
                      tempList.push(self.trainList[x]);
                    }
                  }
                }
                self.trainList = tempList;
              }
            })
            .then(function(){
              if(self.games.length){
                self.games.forEach(function(elem, index){
                  for(let i=0, len=self.trainList.length; i<len; i++ ){
                    if(elem.game_id){
                      if(elem.game_id==self.trainList[i].game_id){
                        self.trainList.splice(i,1);
                        break;
                      }
                    }else if(elem.trainID){
                      if(elem.trainID==self.trainList[i].trainID){
                        self.trainList.splice(i,1);
                        break;
                      }
                    }
                  }
                })
              }
            });
        }
      },
      selectedItem: function (item, index) {
        if (this.selectContent.value == "all") {
          for (var i=0; i<this.trainList.length; i++){
            this.$set(this.trainList[i],"checked",false);
          }
        }else if (this.selectContent.value == "daily") {
          for (var i=0; i<this.trainDailyList.length; i++){
            this.$set(this.trainDailyList[i],"checked",false);
          }
        }else if(this.selectContent.value == "plan"){
          for (var i=0; i<this.trainPlanList.length; i++){
            this.$set(this.trainPlanList[i],"checked",false);
          }
        }
        item.checked = true;
        this.checkItem = item;
        this.showDoTrain = false;
      },
      traincontentCall:function(p1,p2,p3){
        if(typeof p3 == 'undefined'){
          this.oneGrade = p1;
          this.twoGrade = p2;
          this.fetch();
        } else {
          this.fetch(p3);
        }
      },
      cancelhandler(){
        this.$emit('close');
      },
      repairMuseui(){
        $(".mu-dialog-body").css({"padding-left":"0","margin-left":"20px"});
      },
      toTrain(){
        //通过设置难度等级和游戏时间开始训练
        this.$parent.showModal = false;
        this.$emit('submitData',this.checkItem);
      },
      submitAction(){
        if(this.checkItem.p_id){
          this.dialog = true;
          this.$store.commit("getData",this.checkItem);//将选中游戏的信息传给vuex，selectLevel需要
        }else{
          this.$parent.showModal = false;
          this.$emit('submitData',this.checkItem);
        }
      },
      show: function()
      {
        this.resetData();
        this.showDialog = true;
      },
    },
    beforeDestroy(){
      if(!this.addPlan){
        return;
      }
      this.checkItem.forEach(function(item, index){
        item.checked = false;
      });
    }
  })
</script>
<style lang="stylus">
  @import "../../../../assets/css/app.styl"
  @import "../../../../assets/css/variable.styl"

  .train-now
    width 1012px !important
    max-width 1012px !important
    .mu-dialog-actions
      min-height 0 !important
      padding 0px !important
    .mu-dialog-body
      overflow auto !important
  .evalItem
    padding-top 30px
    position relative
    .mengban
      position absolute
      top 110px
      left 70px
  .touming
    position relative
  .touming::after
    content ' '
    position absolute
    left 0
    top 0
    display inline-block
    width 140px
    height 140px
    background-color #000
    opacity 0.5
  .hideImg
    display none
  .u-train-doc
    text-align left
  button#doTrain
    background-color: #ccc;
  /*菜单样式*/
  .evalMenu
    border-bottom 1px solid #eee
    span
      display inline-block
      height 60px
      line-height 60px
      text-align center
      cursor pointer
    .u-second
      line-height 60px
    .nowtrain
      line-height 75px
    div
      display inline
    :hover
        color $color-font-primary
    :active
      color $color-font-primary
    .u-first
      width 77px
      padding-left 35px
  .on
    font-weight bold
  .on1
    color #444
  .on1.u-second
    opacity 1
  .no-content
    font-size: 14px;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:60px;
  .modalList-train
    min-height 300px
  #showChoose
    option
      font-size 14px
  .modal-footer
    position relative
  .count-wrapper
    position absolute
    right 0
    width 200px
    height 20px
    color #E75710
  .conf-cancel-btn
    background-color #999999!important
  .diaClass
    width 500px !important
    max-width 500px !important
    height 350px !important
    max-height 350px !important
    .mu-dialog-actions
      position relative
      margin-top 20px!important
  .title
    justify-content center!important
    border-bottom 1px solid #EEEEEE
    color #333333
    font-size 16px
    font-weight bold
  .bodyClass
    margin-top 50px
</style>





// WEBPACK FOOTER //
// trainModal.vue?dee2c678